export enum Installments {
  O = 'O',
  P = 'P',
  SL36 = 'SL36',
  SL48 = 'SL48',
}

export type Item = {
  name: string;
  quantity: number;
};

export type Promotion = {
  title: string;
  description: string;
};

export type Price = {
  value: number;
  currencyCode: string;
};

type TransactionRate = {
  percentage: number;
  fixedAmount: Price;
};

type TransactionRates = {
  keyedInRate: TransactionRate;
  inPersonRate: TransactionRate;
};

export type Pricing = {
  transactionRates: TransactionRates;
  monthlyPrice: Price;
  additionalDevicePrice: Price;
};

export type Plan = {
  term: Installments;
  price: number;
};

export type Plans = Plan[];
